import { CompanyResponse, RegistryCompanyResponse } from 'generated/api-client';
import { Company, CountryCode } from 'modules/company/types/company.type';
import { CompanyFormFields } from 'modules/company/types/companyFormFields.type';
import { formatAddress } from 'utils/format-address';

const countryCodeMap = {
  FR: CountryCode.FR,
  BE: CountryCode.BE,
} satisfies Record<CompanyResponse['countryCode'], CountryCode>;

export const mapCompanyResponseToCompany = (
  data: CompanyResponse,
): Company => ({
  name: data.name,
  countryCode: countryCodeMap[data.countryCode],
  registrationNumber: data.registrationNumber,
  legalForm: data.legalForm,
  vatNumber: data.vatNumber,
  address: {
    streetAddress: data.address.streetAddress,
    postalCode: data.address.postalCode,
    city: data.address.city,
  },
  billingEmail: data.billingEmail,
});

export const mapRegistryCompanyResponseToFormFields = (
  organization: RegistryCompanyResponse,
): Omit<CompanyFormFields, 'billingEmail' | 'vatNumber'> => {
  return {
    name: organization.name,
    registrationNumber: organization.siret,
    legalForm: organization.legalForm,
    address: {
      streetAddress: organization.address.streetAddress,
      postalCode: organization.address.postalCode,
      city: organization.address.city,
    },
    formattedAddress: formatAddress({
      street: organization.address.streetAddress,
      postalCode: organization.address.postalCode,
      city: organization.address.city,
    }),
    countryCode: countryCodeMap[organization.countryCode],
  };
};
